<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>分享统计</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          />
          <el-table-column
            prop="count"
            label="分享次数"
            align="center"
          />
          <el-table-column
            prop="user"
            label="分享人数"
            align="center"
          />
          <el-table-column
            prop="reward"
            label="奖励领取人数"
            align="center"
          />
          <el-table-column
            prop="reward_rate"
            label="领取率"
            align="center"
          >
            <template v-slot:default="scope">
              {{ scientificFormat(scope.row.reward_rate) }}%
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <shareCountStat ref="userStat" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <shareUserStat ref="shareUser" />
        </el-col>
      </el-row>
    </template>
  </BasicLayout>
</template>

<script>
import { getShareStat } from '@/api/user/user_info'
import shareCountStat from '@/views/config/share-stat/components/share-count-stat.vue'
import shareUserStat from '@/views/config/share-stat/components/share-user-stat.vue'
import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
export default {
  name: 'ShareStat',
  components: {
    shareCountStat,
    shareUserStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }

    this.getTables(undefined)
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getShareStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.tableData = res.data
        this.$refs.userStat.refresh(this.tableData)
        this.$refs.shareUser.refresh(this.tableData)
        // this.$refs.buildAvg.refresh(this.tableData)
        // this.$refs.buildNum.refresh(this.tableData)
      })
    }
  }
}
</script>

<style scoped>
</style>
